export default "__VITE_ASSET__z6N$mH4A__"